import { all, put, call, takeEvery } from 'redux-saga/effects'
import axios from 'axios'
import * as actions from './actions'
import {
  ACCESSTOKEN,
  COMPANY_ID,
  USER_ID,
} from './../../../constants/local_storage'

function* loadPlantMiningContract(action) {
  const {
    data: {
      page,
      pageSize,
      orderBy,
      orderType,
      accessToken,
      company_id,
      is_admin,
      is_vendor,
      location_visibility,
      filterObj,
      limit_export,
      type,
      file_value_pdf,
      exactly_location,
      mill_location_list,
      plant_location_list,
      material_visibility,
    },
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply/get/plant-mining-contract`,
      {
        page,
        pageSize,
        orderBy,
        orderType,
        company_id,
        is_admin,
        is_vendor,
        location_visibility,
        filterObj,
        limit_export,
        type,
        file_value_pdf,
        exactly_location,
        mill_location_list,
        plant_location_list,
        material_visibility,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )
    yield put(actions.loadPlantMiningContract.success(res.data, page, pageSize))
  } catch (err) {
    console.log(err.message)
    yield put(actions.loadPlantMiningContract.failure())
  }
}

function* exportPlantMiningContract(action) {
  const {
    data: {
      page,
      pageSize,
      orderBy,
      orderType,
      accessToken,
      company_id,
      is_admin,
      is_vendor,
      location_visibility,
      filterObj,
      limit_export,
      type,
      file_value_pdf,
      exactly_location,
      mill_location_list,
      plant_location_list,
      material_visibility,
    },
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply/get/plant-mining-contract`,
      {
        page,
        pageSize,
        orderBy,
        orderType,
        company_id,
        is_admin,
        is_vendor,
        location_visibility,
        filterObj,
        limit_export,
        type,
        file_value_pdf,
        exactly_location,
        mill_location_list,
        plant_location_list,
        material_visibility,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )
    yield put(
      actions.exportPlantMiningContract.success(res.data, page, pageSize)
    )
    const sftpPath = res.data.data
    const downloadRes = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/download-report`,
      { sftp_path: sftpPath },
      { headers: { Authorization: `Bearer ${accessToken}` }, responseType: 'blob' },
    )
    const ext = sftpPath.split('.').pop().toLowerCase()
    const mimeType = ext === 'csv' ? 'text/csv' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    const blob = new Blob([downloadRes.data], { type: mimeType })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = sftpPath.split('/').pop()
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    window.URL.revokeObjectURL(url)
  } catch (err) {
    console.log(err.message)
    yield put(actions.exportPlantMiningContract.failure())
  }
}

function* createPlantMiningContract(action) {
  const {
    data: {
      contract_overlaps_id,
      contract_type,
      contract_condition,
      plant_id,
      mining_id,
      material_id,
      distance,
      duration,
      vendor_id,
      contract_shipping_rate,
      manpower_rate,
      tons_per_trip,
      is_bluenet,
      integrated_with,
      sync_cdas,
      config_in_plant_area,
      config_dn_switching,
      contract_number,
      start_at,
      expired_at,
      weighing_format, //รูปเเบบการชั่ง เช่น M, P, MP,
      weighing_random_conditions, // เงื่อนไขการสุ่มชั่งน้ำหนัก
      config_weight1_source,
      config_weight1_weight_in,
      config_weight1_weight_out,
      config_weight2_source,
      config_weight2_weight_in,
      config_weight2_weight_out,
      config_delivery_area,
      config_gr_delivery_area,
      origin_sample_photo_pattern_id,
      dest_sample_photo_pattern_id,
      interface_gr,
      weigh_per_trip,
      weigh_unit,
      origin_sample_photo_pattern_required,
      dest_sample_photo_pattern_required,
      assess_product_quality,
      calculate_route,
      edit_dest_weight_total,
      isupply_excess_charge_form_pattern_has_isupply_material_id,
      edit_origin_location,
      edit_dest_location,
      edit_dest_weight_total_is_required,
      edit_ref_do_number,
      edit_ref_do_number_is_required,
      enable_shipment,
      shipment_is_required,
      photo_assess_product_quality_is_required,
      enable_do_approval,
      lead_time,
      source_lock,
      auto_select_silo_no,
      contractor_dayoff,
      delivery_date_cutoff,
      delivery_time_cutoff,
      require_sap_no,
      config_in_source_area,
      effective_date,
      expirt_date,
    },
    loading,
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply/create/plant-mining-contract`,
      {
        contract_overlaps_id,
        contract_type,
        contract_condition,
        plant_id,
        mining_id,
        material_id,
        distance,
        duration,
        vendor_id,
        contract_shipping_rate,
        manpower_rate,
        tons_per_trip,
        is_bluenet,
        integrated_with,
        sync_cdas,
        config_in_plant_area,
        config_dn_switching,
        contract_number,
        start_at,
        expired_at,
        weighing_format, //รูปเเบบการชั่ง เช่น M, P, MP,
        weighing_random_conditions, // เงื่อนไขการสุ่มชั่งน้ำหนัก
        config_weight1_source,
        config_weight1_weight_in,
        config_weight1_weight_out,
        config_weight2_source,
        config_weight2_weight_in,
        config_weight2_weight_out,
        config_delivery_area,
        config_gr_delivery_area,
        origin_sample_photo_pattern_id,
        dest_sample_photo_pattern_id,
        interface_gr,
        weigh_per_trip,
        weigh_unit,
        origin_sample_photo_pattern_required,
        dest_sample_photo_pattern_required,
        assess_product_quality,
        calculate_route,
        edit_dest_weight_total,
        isupply_excess_charge_form_pattern_has_isupply_material_id,
        edit_origin_location,
        edit_dest_location,
        edit_dest_weight_total_is_required,
        edit_ref_do_number,
        edit_ref_do_number_is_required,
        enable_shipment,
        shipment_is_required,
        photo_assess_product_quality_is_required,
        enable_do_approval,
        lead_time,
        source_lock,
        matching_name: 'isupply-contract',
        action_name: 'add',
        auto_select_silo_no,
        contractor_dayoff,
        delivery_date_cutoff,
        delivery_time_cutoff,
        require_sap_no,
        config_in_source_area,
        effective_date,
        expirt_date,
      },
      { headers: { Authorization: `Bearer ${ACCESSTOKEN}` } }
    )
    loading(res.data)
    yield put(actions.createPlantMiningContract.success(res.data))
  } catch (err) {
    yield put(actions.createPlantMiningContract.failure())
  }
}

function* loadPlantMiningContractDetail(action) {
  const {
    data: { id, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.get,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply/get-detail/plant-mining-contract/${id}`,
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )
    yield put(actions.loadPlantMiningContractDetail.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.loadPlantMiningContractDetail.failure())
  }
}

function* updatePlantMiningContractDetail(action) {
  const {
    data: {
      contract_overlaps_id,
      id,
      contract_type,
      contract_condition,
      plant_id,
      mining_id,
      material_id,
      distance,
      duration,
      vendor_id,
      contract_shipping_rate,
      manpower_rate,
      shipping_rate,
      tons_per_trip,
      is_bluenet,
      integrated_with,
      sync_cdas,
      isupply_plant_mining_contract_config_id,
      config_in_plant_area,
      config_dn_switching,
      contract_number,
      start_at,
      expired_at,
      weighing_format, //รูปเเบบการชั่ง เช่น M, P, MP,
      weighing_random_conditions, // เงื่อนไขการสุ่มชั่งน้ำหนัก
      config_weight1_source,
      config_weight1_weight_in,
      config_weight1_weight_out,
      config_weight2_source,
      config_weight2_weight_in,
      config_weight2_weight_out,
      config_delivery_area,
      config_gr_delivery_area,
      origin_sample_photo_pattern_id,
      dest_sample_photo_pattern_id,
      interface_gr,
      weigh_per_trip,
      weigh_unit,
      origin_sample_photo_pattern_required,
      dest_sample_photo_pattern_required,
      assess_product_quality,
      calculate_route,
      edit_dest_weight_total,
      isupply_excess_charge_form_pattern_has_isupply_material_id,
      edit_origin_location,
      edit_dest_location,
      edit_dest_weight_total_is_required,
      edit_ref_do_number,
      edit_ref_do_number_is_required,
      enable_shipment,
      shipment_is_required,
      photo_assess_product_quality_is_required,
      enable_do_approval,
      lead_time,
      source_lock,
      auto_select_silo_no,
      contractor_dayoff,
      delivery_date_cutoff,
      delivery_time_cutoff,
      require_sap_no,
      config_in_source_area,
      effective_date,
      expirt_date,
    },
    loading,
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply/update/plant-mining-contract`,
      {
        contract_overlaps_id,
        id,
        contract_type,
        contract_condition,
        plant_id,
        mining_id,
        material_id,
        distance,
        duration,
        vendor_id,
        contract_shipping_rate,
        manpower_rate,
        shipping_rate,
        tons_per_trip,
        is_bluenet,
        integrated_with,
        sync_cdas,
        isupply_plant_mining_contract_config_id,
        config_in_plant_area,
        config_dn_switching,
        contract_number,
        start_at,
        expired_at,
        weighing_format, //รูปเเบบการชั่ง เช่น M, P, MP,
        weighing_random_conditions, // เงื่อนไขการสุ่มชั่งน้ำหนัก
        config_weight1_source,
        config_weight1_weight_in,
        config_weight1_weight_out,
        config_weight2_source,
        config_weight2_weight_in,
        config_weight2_weight_out,
        config_delivery_area,
        config_gr_delivery_area,
        origin_sample_photo_pattern_id,
        dest_sample_photo_pattern_id,
        interface_gr,
        weigh_per_trip,
        weigh_unit,
        origin_sample_photo_pattern_required,
        dest_sample_photo_pattern_required,
        assess_product_quality,
        calculate_route,
        edit_dest_weight_total,
        isupply_excess_charge_form_pattern_has_isupply_material_id,
        edit_origin_location,
        edit_dest_location,
        edit_dest_weight_total_is_required,
        edit_ref_do_number,
        edit_ref_do_number_is_required,
        enable_shipment,
        shipment_is_required,
        photo_assess_product_quality_is_required,
        enable_do_approval,
        lead_time,
        source_lock,
        matching_name: 'isupply-contract',
        action_name: 'edit',
        auto_select_silo_no,
        contractor_dayoff,
        delivery_date_cutoff,
        delivery_time_cutoff,
        require_sap_no,
        config_in_source_area,
        effective_date,
        expirt_date,
      },
      { headers: { Authorization: `Bearer ${ACCESSTOKEN}` } }
    )
    loading(res.data)
    yield put(actions.updatePlantMiningContractDetail.success(res.data))
  } catch (err) {
    yield put(actions.updatePlantMiningContractDetail.failure())
  }
}

function* uploadPlantMiningContract(action) {
  const {
    data: {
      files,
      accessToken,
      is_bluenet,
      integrated_with,
      sync_cdas,
      config_dn_switching,
      weighing_format,
      weighing_random_conditions,
      config_weight1_source,
      config_weight1_weight_in,
      config_weight1_weight_out,
      config_weight2_source,
      config_weight2_weight_in,
      config_weight2_weight_out,
      config_delivery_area,
      config_gr_delivery_area,
      origin_sample_photo_pattern_id,
      dest_sample_photo_pattern_id,
      interface_gr,
      typeImport,
      origin_sample_photo_pattern_required,
      dest_sample_photo_pattern_required,
      assess_product_quality,
      calculate_route,
      edit_dest_weight_total,
      edit_origin_location,
      edit_dest_location,
      edit_dest_weight_total_is_required,
      edit_ref_do_number,
      edit_ref_do_number_is_required,
      enable_shipment,
      shipment_is_required,
      photo_assess_product_quality_is_required,
      enable_do_approval,
      isupply_excess_charge_form_pattern_has_isupply_material_id,
      auto_select_silo_no,
      require_sap_no,
      config_in_source_area,
    },
    loading,
  } = action.payload

  const formData = new FormData()
  let uploadFile = null

  if (files != null) {
    files.forEach((File) => {
      uploadFile = File
    })
  }

  formData.append('files', uploadFile)
  formData.append('is_bluenet', is_bluenet)
  formData.append('integrated_with', integrated_with)
  formData.append('sync_cdas', sync_cdas)
  formData.append('config_dn_switching', config_dn_switching)
  formData.append('weighing_format', weighing_format)
  formData.append('weighing_random_conditions', weighing_random_conditions)
  formData.append('config_weight1_source', config_weight1_source)
  formData.append('config_weight1_weight_in', config_weight1_weight_in)
  formData.append('config_weight1_weight_out', config_weight1_weight_out)
  formData.append('config_weight2_source', config_weight2_source)
  formData.append('config_weight2_weight_in', config_weight2_weight_in)
  formData.append('config_weight2_weight_out', config_weight2_weight_out)
  formData.append('config_delivery_area', config_delivery_area)
  formData.append('config_gr_delivery_area', config_gr_delivery_area)
  formData.append(
    'origin_sample_photo_pattern_id',
    origin_sample_photo_pattern_id
  )
  formData.append('dest_sample_photo_pattern_id', dest_sample_photo_pattern_id)
  formData.append('interface_gr', interface_gr)
  formData.append('typeImport', typeImport)
  formData.append(
    'origin_sample_photo_pattern_required',
    origin_sample_photo_pattern_required
  )
  formData.append(
    'dest_sample_photo_pattern_required',
    dest_sample_photo_pattern_required
  )
  formData.append('assess_product_quality', assess_product_quality)
  formData.append('calculate_route', calculate_route)
  formData.append('edit_dest_weight_total', edit_dest_weight_total)
  formData.append('edit_origin_location', edit_origin_location)
  formData.append('edit_dest_location', edit_dest_location)
  formData.append(
    'edit_dest_weight_total_is_required',
    edit_dest_weight_total_is_required
  )
  formData.append('edit_ref_do_number', edit_ref_do_number)
  formData.append(
    'edit_ref_do_number_is_required',
    edit_ref_do_number_is_required
  )
  formData.append('enable_shipment', enable_shipment)
  formData.append('shipment_is_required', shipment_is_required)
  formData.append(
    'photo_assess_product_quality_is_required',
    photo_assess_product_quality_is_required
  )
  formData.append('enable_do_approval', enable_do_approval)
  formData.append(
    'isupply_excess_charge_form_pattern_has_isupply_material_id',
    isupply_excess_charge_form_pattern_has_isupply_material_id
  )
  formData.append('auto_select_silo_no', auto_select_silo_no)
  formData.append('require_sap_no', require_sap_no)
  formData.append('config_in_source_area', config_in_source_area)

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply/import/plant-mining-contract`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    )
    loading(res.data)
    yield put(actions.uploadPlantMiningContract.success(res.data))
  } catch (err) {
    console.log(err)
    yield put(actions.uploadPlantMiningContract.failure())
  }
}

function* loadSeqForSecondaryContract(action) {
  const {
    data: { plant_id, material_id, accessToken },
    loading,
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply/get/seq-for-secondary-contract`,
      {
        plant_id,
        material_id,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )
    yield put(actions.loadSeqForSecondaryContract.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.loadSeqForSecondaryContract.failure())
  }
}

function* updateSeqForSecondaryContract(action) {
  const {
    data: { secondary_contract_list, accessToken },
    loading,
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply/update/seq-for-secondary-contract`,
      {
        secondary_contract_list,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )
    loading(res.data)
    yield put(actions.updateSeqForSecondaryContract.success(res.data))
  } catch (err) {
    yield put(actions.updateSeqForSecondaryContract.failure())
  }
}

export default function* watchPlantMiningContract() {
  yield all([
    takeEvery(
      actions.LOAD_PLANT_MINING_CONTRACT.REQUEST,
      loadPlantMiningContract
    ),
    takeEvery(
      actions.CREATE_PLANT_MINING_CONTRACT.REQUEST,
      createPlantMiningContract
    ),
    takeEvery(
      actions.LOAD_PLANT_MINING_CONTRACT_DETAIL.REQUEST,
      loadPlantMiningContractDetail
    ),
    takeEvery(
      actions.UPDATE_PLANT_MINING_CONTRACT.REQUEST,
      updatePlantMiningContractDetail
    ),
    takeEvery(
      actions.UPLOAD_PLANT_MINING_CONTRACT.REQUEST,
      uploadPlantMiningContract
    ),
    takeEvery(
      actions.EXPORT_PLANT_MINING_CONTRACT.REQUEST,
      exportPlantMiningContract
    ),
    takeEvery(
      actions.LOAD_SEQ_FOR_SECONDARY_CONTRACT.REQUEST,
      loadSeqForSecondaryContract
    ),
    takeEvery(
      actions.UPDATE_SEQ_FOR_SECONDARY_CONTRACT.REQUEST,
      updateSeqForSecondaryContract
    ),
  ])
}
export {
  loadPlantMiningContract,
  createPlantMiningContract,
  updatePlantMiningContractDetail,
  loadPlantMiningContractDetail,
  uploadPlantMiningContract,
  exportPlantMiningContract,
  loadSeqForSecondaryContract,
  updateSeqForSecondaryContract,
}
